<template>
  <div class="page">
    <div class="highlight">
      <div class="highlight-top">
        <div class="highlightTitle">{{ props.data.titleCn }}</div>
        <div class="highlightEn">{{ props.data.titleEn }}</div>
      </div>
      <div class="highlight-bottom">
        <swiper
          :modules="[Autoplay]"
          :slides-per-view="'auto'"
          :centered-slides="true"
          :space-between="20"
          :loop="true"
          :autoplay="{
            delay: 3000,
            disableOnInteraction: false
          }"
        >
          <swiper-slide v-for="(item, index) in props.data.list" :key="index">
            <div class="bottom-item">
              <img :src="item.imgUrl" alt="slide image" />
              <div class="item-content">{{ item.content }}</div>
            </div>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper/modules'
import 'swiper/swiper-bundle.css'

const props = defineProps({
  data: {
    type: Object,
    default: {}
  }
})

</script>

<style lang="scss" scoped>
.page{
  width: 100%;
  display: flex;
  justify-content: center;
  .highlight {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 72px;
    .highlight-top{
      display: flex;
      flex-direction: column;
      align-items: center;
      .highlightTitle {
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 32px;
        font-weight: 700;
        line-height: 32px;
        letter-spacing: 0px;
        text-transform: uppercase;
      }
      .highlightEn {
        color: rgb(44, 44, 44);
        font-family: Rubik;
        font-size: 14px;
        font-weight: 400;
        line-height: 14px;
        letter-spacing: 0px;
        text-transform: uppercase;
        margin-top: 12px;
      }
    }
    .highlight-bottom{
      width: 100%;
      display: flex;
      margin-top: 32px;
      .bottom-item{
        position: relative;
        .item-content{
          width: 203px;
          position: absolute;
          left: 30px;
          top: 158px;
          color: rgb(44, 44, 44);
          font-family: Source Han Sans;
          font-size: 16px;
          font-weight: 400;
          line-height: 28px;
          letter-spacing: 0px;
          text-align: justify;
          text-transform: uppercase;
        }
      }
    }
  }
  .swiper-slide {
    width: 264px;
  }

  .swiper-slide img {
    width: 100%;
    display: block;
  }
}
</style>
